import React from 'react'
import { FaFacebookF, FaInstagram, FaLinkedinIn } from "react-icons/fa";
import { contactImgOne } from "../../assets/index";

const ContactLeft = () => {
  return (
    <div className="w-full lgl:w-[35%] h-full bg-gradient-to-r from-[#1e2024] to-[#23272b] p-4 lgl:p-8 rounded-lg shadow-shadowOne flex flex-col gap-8 justify-center" data-aos="zoom-in-up">
      <img
        className="w-full h-64 object-cover rounded-lg mb-2"
        src={contactImgOne}
        alt="contactImgOne"
      />
      <div className="flex flex-col gap-4">
        <h3 className="text-3xl font-bold text-white">King Jesse Damilare</h3>
        <p className="text-lg font-normal text-gray-400">
          Front Web Developer
        </p>
        <p className="text-base text-gray-400 tracking-wide">
        Feel free to get in touch with me. I am always open to discussing a new projects, creative ideas or opportunities and to be part of your vision. We craft web solutions with powerful technologies.
        </p>
        <p className="text-base text-gray-400 flex items-center gap-2">
          Phone: <span className="text-lightText">08026138537</span>
        </p>
        <p className="text-base text-gray-400 flex items-center gap-2">
          Email: <span className="text-lightText">daremiah_4real@yahoo.com</span>
        </p>
      </div>
      <div className="flex flex-col gap-4">
        <h2 className="text-base uppercase font-titleFont mb-4">Find me in</h2>
        <div className="flex gap-4">
          <span className="bannerIcon">
          <a href="https://www.facebook.com/Dammietech"target="_blank"><FaFacebookF /></a>
            
          </span>
          <span className="bannerIcon">
          <a href="https://www.instagram.com/Dammietech"target="_blank"><FaInstagram /></a>
            
          </span>
          <span className="bannerIcon">
          <a href="https://www.linkedin.com/in/oluwadamilare-jesse-85950b85/"target="_blank"><FaLinkedinIn/></a>
          
          </span>
        </div>
      </div>
    </div>
  );
}

export default ContactLeft